import { useMemo } from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import ModuleCategoryTypeUrls from './urls/ModuleCategory';
import ModuleDetailsContainer from './containers/ModuleDetailsContainer';
import ModuleDetailsPreviewContainer from './containers/ModuleDetailsPreviewContainer';
import StorefrontUsageTrackerProvider from '../context/StorefrontUsageTrackerProvider';
import { getPaginatedRoute } from '../utils/pagination';
import AssetStorefrontContainer from '../storefront/containers/AssetStorefrontContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const categories = Object.values(ModuleCategoryTypeUrls).join('|');
const categoryRouteParam = `:category(${categories})`;
export default function ModulesRoutes() {
  const {
    path
  } = useRouteMatch();
  const categoryRoutes = useMemo(() => [`${path}/${categoryRouteParam}`, getPaginatedRoute(`${path}/${categoryRouteParam}`)], [path]);
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: `${path}/_preview/:slug`,
      exact: true,
      sensitive: true,
      children: /*#__PURE__*/_jsx(ModuleDetailsPreviewContainer, {})
    }), /*#__PURE__*/_jsx(Route, {
      path: [path, getPaginatedRoute(path), ...categoryRoutes],
      exact: true,
      children: /*#__PURE__*/_jsx(StorefrontUsageTrackerProvider, {
        children: /*#__PURE__*/_jsx(AssetStorefrontContainer, {})
      })
    }), /*#__PURE__*/_jsx(Route, {
      path: [`${path}/:slug`, `${path}/:slug/write-review`],
      exact: true,
      sensitive: true,
      children: /*#__PURE__*/_jsx(ModuleDetailsContainer, {})
    }), /*#__PURE__*/_jsx(Redirect, {
      to: path
    })]
  });
}